import { Icon } from '../Icon';

export const SocialNameInfoTooltip = () => (
  <div className="relative inline-flex items-center group ml-1">
    <Icon.Info width={15} height={15} className="cursor-pointer shrink-0" />

    <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 hidden group-hover:block w-72 px-3 py-2 rounded-md bg-gray-800 text-white text-xs break-words whitespace-normal shadow-lg z-50">
      Conforme Decreto nº 8.727/2016, Nome Social se refere à designação pela qual a
      pessoa travesti ou transexual se identifica e é socialmente reconhecida.
    </div>
  </div>
);
